import { useState } from "react";

export const GenericBankFeedsAccountName = ({
  id,
  text,
  width,
}: {
  id: string;
  text: string;
  width?: string;
}) => {
  const [display, setDisplay] = useState(false);
  return (
    <div
      onMouseEnter={() => {
        const div = document.querySelector("#id_" + id);
        // Only display hover text if the original text is truncated.
        setDisplay(!!div && div.scrollWidth > div.clientWidth);
      }}
      onMouseLeave={() => {
        setDisplay(false);
      }}
      style={{ position: "relative", overflow: "visible" }}>
      <div
        id={"id_" + id}
        style={{
          width: width ?? "170px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}>
        {text}
      </div>
      {display && (
        <div
          style={{
            whiteSpace: "normal",
            position: "absolute",
            top: "70%",
            backgroundColor: "#fff",
            color: "black",
            border: "1px solid rgba(42, 47, 69, .17)",
            padding: "1px 10px",
            borderRadius: "4px",
            zIndex: 10000000,
            fontSize: "12px",
            pointerEvents: "none",
            opacity: 1,
          }}>
          {text}
        </div>
      )}
    </div>
  );
};
